import extendNode from '../extendNode.mjs'
import useCategoryNode from '../_CATEGORY/useCategoryNode.jsx'
import meta from './metaBdRule.mjs'

export default () => {
    const CategoryNode = useCategoryNode()

    return extendNode(CategoryNode, {
        ...meta,

        canMountType(map, node, type) {
            return /^(BDRULE|CAT)$/.test(type)
        },

        isHidden(map, node) {
            const {bdType} = node.parent?.data ?? {}

            return (
                '3' === bdType ||
                CategoryNode.isHidden.call(this, map, node)
            )
        },

        menuItemsInsertCommon(map, node) {
            return [
                {type: 'CAT'},
            ]
        },

        menuItemsInsertConcept(map, node) {
            return [
                {type: 'BDRULE'},
            ]
        },
    })
}
